import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect, useRef } from "react";

import SpecialText from '../fragments/SpecialText';

export default function Quotes({ block }) {

    const quotes = Array.isArray(block?.quotes) && block.quotes.length
        ? block.quotes
        : (block?.quote || block?.source)
            ? [{ quote: block.quote, source: block.source }]
            : [];

    const [activeIndex, setActiveIndex] = useState(0);
    const [containerHeight, setContainerHeight] = useState(null);
    const quotesContainerRef = useRef(null);
    const text_maximum_width = block.text_maximum_width ? block.text_maximum_width + 'em' : '30em';

    useEffect(() => {
        setActiveIndex(0);
    }, [quotes.length]);

    useEffect(() => {
        if (quotes.length <= 1) return;
        const intervalId = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % quotes.length);
        }, 5000);
        return () => clearInterval(intervalId);
    }, [quotes.length]);

    useEffect(() => {
        if (!quotesContainerRef.current) return;
        const updateHeight = () => {
            if (!quotesContainerRef.current) return;
            const quoteNodes = quotesContainerRef.current.querySelectorAll('.c-quote');
            let maxHeight = 0;
            quoteNodes.forEach((node) => {
                const nodeHeight = node.offsetHeight || 0;
                if (nodeHeight > maxHeight) maxHeight = nodeHeight;
            });
            setContainerHeight(maxHeight || null);
        };

        updateHeight();

        if (typeof window === 'undefined') return;
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, [quotes.length, text_maximum_width]);

    const textRevealRef = useReveal({ once: true });

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--quote`}>
            <div className={`l-grid`}>
                <div className={`l-grid__col`}>
                    <div 
                        className="c-quotes c-transition-in--top-border c-transition-in c-transition-in--bottom-border"
                        ref={textRevealRef}
                    >
                        <div className="c-quotes__inner l-small-top-padding l-small-bottom-padding">
                            <div
                                className="c-quotes__inner "
                                ref={quotesContainerRef}
                                style={containerHeight ? { height: `${containerHeight}px` } : undefined}
                            >
                                {quotes.map((quoteItem, index) => (
                                    <>
                                        <div
                                            key={index}
                                            className={`c-quote ${index === activeIndex ? 'state-active' : ''}`}
                                        >
                                            {quoteItem.quote &&
                                                <h3 className="c-quote__text c-heading c-heading--accent" style={{ maxWidth: text_maximum_width }}>
                                                    <SpecialText text={quoteItem.quote} />
                                                </h3>
                                            }
                                            {quoteItem.source &&
                                                <p className="c-quote__cite c-paragraph" dangerouslySetInnerHTML={{__html:quoteItem.source}} />
                                            }
                                        </div>
                                        {quoteItem.source &&
                                            <p className={`c-quote__cite c-paragraph ${index === activeIndex ? 'state-active' : ''}`} dangerouslySetInnerHTML={{__html:quoteItem.source}} />
                                        }
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}